<template>
  <div class="login-page">
    <form @submit.stop.prevent>
      <template v-if="error">
        <h2>Acesso indisponível</h2>
        <span>{{ error }}</span>
        <router-link
          class="btn btn-lg btn-primary btn-block mt-2"
          to="/login"
        >Ir para o login</router-link>
      </template>
      <template v-else>
        <h2>Acesso de suporte</h2>
        <span>Validando o link de acesso</span>
        <div class="form-body text-center">
          <div class="loading loading-lg"></div>
        </div>
      </template>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

const DEFAULT_ERROR = 'Este link não é mais válido. '
  + 'Gere um novo acesso temporário no Console.';

export default {
  name: 'SupportAccess',
  data() {
    return {
      error: null,
    };
  },
  mounted() {
    this.redeem();
  },
  methods: {
    ...mapActions(['redeemSupportAccess']),
    redeem() {
      const { ticket } = this.$route.params;

      this.redeemSupportAccess(ticket)
        .then(() => this.$router.replace({ path: '/home' }))
        .catch((e) => {
          const reason = e.response?.data?.reason ?? null;

          this.error = reason === 'tooManyAttempts'
            ? 'Muitas tentativas a partir deste endereço. Tente novamente em alguns minutos.'
            : DEFAULT_ERROR;
        });
    },
  },
};
</script>
